<template>
  <a-form
    :model="formState"
    style="position: relative;"
    ref="formRef"
    :labelCol="labelCol"
    :wrapperCol="wrapperCol"
    labelAlign="right"
    :colon="true"
    class="action_form"
  >
    <div
      v-for="(dynamic, dynamicIndex) in formState"
      :key="dynamic[idField]"
      :style="{
        display: 'flex',
        flexDirection: 'column',
        // 'margin-bottom': ' 8px',
        width: ' 100%',
        // 'flex-wrap': 'wrap',
        // position: 'relative',
        // 'border-top': dynamicIndex !== 0 ? '1px dashed #8080809c' : 'none',
        // paddingTop: dynamicIndex !== 0 ? '20px' : '0',
      }"
    >
      <template v-for="item in props.collection" :key="item.field">
        <a-form-item
          :label="item.label"
          :style="{
            height: ['image', 'imgUpload', 'textarea'].includes(item.type) ? 'auto' : props.itemHeight,
            // width: item.width || props.itemWidth,
            width: '100%'
          }"
          :required="item.required === undefined ? true : item.required"
        >
          <template v-if="item.tips">
            <a-popover title="提示">
              <template #content>
                <p v-for="tips in item.tips" :key="tips">{{ tips }}</p>
              </template>
              <QuestionCircleTwoTone />
            </a-popover>
          </template>
          <template v-if="item.type === 'inputNumber'">
            <InputNumber v-bind="item" v-model="dynamic[item.field]" />
          </template>
          <template v-else-if="item.type === 'select'">
            <Select
              v-bind="item"
              v-model="dynamic[item.field]"
              :options="item.options || getOption(item)"
            />
          </template>
          <template v-else-if="item.type === 'radio'">
            <Radio
              v-bind="item"
              v-model="dynamic[item.field]"
              :options="item.options || getOption(item)"
            />
          </template>
          <template v-else-if="item.type === 'dateRange'">
            <DateRange
              v-bind="item"
              v-model:start="dynamic[item.startField]"
              v-model:end="dynamic[item.endField]"
            />
          </template>
          <template v-else-if="item.type === 'date'">
            <DatePicker v-bind="item" v-model="dynamic[item.field]" />
          </template>
          <template v-else-if="item.type === 'imgUpload'">
            <ImgUpload v-bind="item" v-model="dynamic[item.field]" />
          </template>
          <template v-else-if="item.type === 'image'">
            <ImagePreview v-bind="item" v-model="dynamic[item.field]" />
          </template>
          <template v-else-if="item.type === 'textarea'">
            <a-textarea
              v-bind="item"
              v-model="dynamic[item.field]"
              :auto-size="{ minRows: 6, maxRows: 6 }"
            />
          </template>
          <template v-else>
            <Input v-bind="item" v-model="dynamic[item.field]" />
          </template>
        </a-form-item>
      </template>

      <a-button
        v-if="formState.length > 1 && !props.disabled"
        @click="delForm(dynamicIndex)"
        type="primary"
        danger
        shape="circle"
        size="small"
        style="
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
          font-weight: 900;
        "
      >
        —
      </a-button>
    </div>
    <a-button type="dashed" block @click="addForm" v-if="!props.disabled">
      <PlusOutlined />
      添加{{ props.name }}
    </a-button>
  </a-form>
</template>

<script setup>
  import {
    reactive,
    defineProps,
    defineEmits,
    defineExpose,
    toRefs,
    ref,
    watch,
  } from 'vue'
  import Input from '@/components/form/input'
  import InputNumber from '@/components/form/input_number'
  import Select from '@/components/form/select'
  import Radio from '@/components/form/radio'
  import ImgUpload from '@/components/form/img_upload'
  import ImagePreview from '@/components/form/image_preview'
  import DatePicker from '@/components/form/date'
  import { useStore } from 'vuex'
  import DateRange from '@/components/form/date_range'
  import { constantToOptions } from '@/utils/format'
  import { QuestionCircleTwoTone } from '@ant-design/icons-vue'
  //初始化
  const props = defineProps({
    itemWidth: {
      type: String,
      default: '100%',
    },
    itemHeight: {
      type: String,
      default: 'auto',
    },
    labelCol: {
      type: Object,
      default: () => ({ span: 7, offset: 0 }),
    },
    wrapperCol: {
      type: Object,
      default: () => ({ offset: 0 }),
    },
    collection: Array,
    fetchData: Function,
    handelSearch: Function,
    handelAdd: Function,
    name: String,
    id: String,
    editData: Object,
    dataIdFiled: {
      type: String,
      default: 'id',
    },
    disabled: { type: Boolean, default: false },
    edit: { type: Boolean, default: true }, //编辑模式
  })

  const idField = 'dynamic_action_form_id'
  const formRef = ref()
  const emit = defineEmits()
  const formState = reactive(getDefaultState(props.collection))

  function getDefaultState(collection) {
    const defaultState = []
    //编辑，并且有值
    if (props.editData && props.editData[props.id]) {
      const editData = props.editData[props.id]
      editData.forEach((editItem, editIndex) => {
        defaultState[editIndex] = {}
        defaultState[editIndex][idField] = editItem[props.dataIdFiled]
        collection.forEach((item, index) => {
          //处理特殊情况
          if (item.type === 'dateRange') {
            defaultState[editIndex][item.startField] =
              editItem[item.startField] || item.defaultStart
            defaultState[editIndex][item.endField] =
              editItem[item.endField] || item.defaultEnd
          } else if (item.type === 'addressPicker') {
            defaultState[editIndex][item.latField] =
              editItem[item.latField] || item.defaultLat
            defaultState[editIndex][item.lngField] =
              editItem[item.lngField] || item.defaultLng
          } else if (item.type === 'radio' || item.type === 'select') {
            //value转字符串
            defaultState[editIndex][item.field] =
              editItem[item.field] !== undefined
                ? editItem[item.field] + ''
                : item.defaultValue !== undefined
                ? item.defaultValue + ''
                : ''
          } else {
            //正常情况
            defaultState[editIndex][item.field] =
              editItem[item.field] ?? item.defaultValue ?? ''
          }
        })
      })
    }
    //添加
    else {
      defaultState.push({})
      collection.forEach((item) => {
        defaultState[0][idField] = Date.now()
        //处理特殊情况
        if (item.type === 'dateRange') {
          defaultState[0][item.startField] = item.defaultStart
          defaultState[0][item.endField] = item.defaultEnd
        } else if (item.type === 'addressPicker') {
          defaultState[0][item.latField] = item.defaultLat
          defaultState[0][item.lngField] = item.defaultLng
        } else {
          //正常情况
          defaultState[0][item.field] = item.defaultValue || ''
        }
      })
    }
    return defaultState
  }

  function addForm() {
    const formObj = {}
    props.collection.forEach((item) => {
      formObj[idField] = Date.now()
      //处理特殊情况
      if (item.type === 'dateRange') {
        formObj[item.startField] = item.defaultStart
        formObj[item.endField] = item.defaultEnd
      } else if (item.type === 'addressPicker') {
        formObj[item.latField] = item.defaultLat
        formObj[item.lngField] = item.defaultLng
      } else {
        //正常情况
        formObj[item.field] = item.defaultValue || ''
      }
    })
    formState.push(formObj)
  }

  function delForm(index) {
    formState.splice(index, 1)
  }

  watch(formState, () => {})

  defineExpose({
    formState,
  })

  //获取store中的option数据
  const store = useStore()
  const Enum = toRefs(store.state?.common)
  function getOption({
    storeOptions,
    getName = false,
    filterNegative = false,
  } = {}) {
    if (Enum[storeOptions])
      return constantToOptions(Enum[storeOptions].value, {
        filterNegative,
        getName,
      })
    else return []
  }
</script>

<style lang="less" scoped></style>
